import React, { useState } from 'react';
import styles from './NavLayout.module.scss';
import { IconMyCollection, IconStandalone, IconTransitions, programMenuOptions } from '@src/constants';
import { LordIcon } from '@src/components/lord-icon/lord-icon';
import { Dropdown } from "antd";
import ProgramDescription from '@src/components/program-description/ProgramDescription';
import { SllProgram } from '@src/api/graphql-codegen';

type Props = {
  programName: string;
  program: SllProgram;
  isCanada?: boolean;
  isAUuser?: boolean;
  handleSelectProgram?: (program: string) => void;
}

const getIconByProgram = (program: string) => {
  switch (program) {
    case programMenuOptions[0].label:
      return IconMyCollection;
    case programMenuOptions[1].label:
      return IconTransitions;
    case programMenuOptions[2].label:
      return IconStandalone;
    case programMenuOptions[3].label:
      return IconStandalone;
    default: {
      return IconTransitions;
    }
  }
}

function NavLayout(props: Props) {
  const { programName, program, isCanada, isAUuser } = props;

  const [showProgramMenu, setShowProgramMenu] = useState(false);

  const IconSrc = getIconByProgram(programName);

  return (
    <>
      <div id={"navMenuBar"} className={styles.navView}>
        <div className={styles.itemWrapper}>
          <Dropdown menu={{ items: [] }} trigger={isAUuser ? [] : ['click']} placement="bottom" onOpenChange={(visible) => setShowProgramMenu(visible)} open={showProgramMenu}>
            <div className={[styles.listItem, styles.selItem].join(' ')}>
              <LordIcon src={IconSrc} isHover={true} colors={{primary: '#FFB073', secondary: '#FFB073'}} target='.NavLayout_gradeDropDownMenuitem__sBqfP' size={60}/>
              <div className={[styles.listTitle, styles.selItemTitle].join(' ')}>
              {programName}
              </div>
            </div>
          </Dropdown>
        </div>
      </div>
      <ProgramDescription programName={programName} program={program} isAUuser={isAUuser} isCanada={isCanada} />
    </>
  );
}

export default NavLayout;
